(function () {
	'use strict';

	angular.module('smb-app')
		.controller('smbUserSelectorController', [
			'$mdDialog',
			'users',
			'multiSelect',
			UserSelectorController]);

	function UserSelectorController($mdDialog, users, multiSelect) {
		var vm = this;
		vm.users = JSON.parse(JSON.stringify(users)); //clear object reference
		vm.fullItems = JSON.parse(JSON.stringify(users));
		vm.multiple = multiSelect ? true : false;
		vm.style = { width: (vm.fullItems.length * 170) + 'px' };
		vm.filterPhrase = '';

		vm.cancel = function () {
			$mdDialog.cancel();
		};
		vm.add = function () {
			$mdDialog.hide(vm.users.filter(function (user) { return user.selected; }));
		};

		vm.filter = function () {
			if (vm.filterPhrase === '') {
				vm.users = JSON.parse(JSON.stringify(vm.fullItems));
				return;
			}
			
			var filter = vm.filterPhrase.toLowerCase();
			vm.users = vm.fullItems.filter(function (item) {
				if (item.UserGroupId) {
					return item.UserGroupName.toLowerCase().indexOf(filter) > -1;
				}
				else if (item.UserId) {
					var nameEmail = item.UserName.toLowerCase() + ' ' + item.EmailAddress.toLowerCase();
					return nameEmail.toLowerCase().indexOf(filter) > -1;
				}
				else if (item.StatusType) {
					return item.Label.toLowerCase().indexOf(filter) > -1;
				}
				else if (item.IconUserFriendlyName) {
					return item.IconUserFriendlyName.toLowerCase().indexOf(filter) > -1;
				}
			});

		};
	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/userSelectorDialog/userSelectorDialog.js
// module id = 104
// module chunks = 1